import React, { useEffect, useState } from "react";
import UsersTable from "./components/UsersTable";
import Edit from "./modals/Edit";
import View from "./modals/View";
import Filter from "./modals/Filter";
import Divider from "@material-ui/core/Divider/index";
import Switch from "@material-ui/core/Switch/index";
import FormControlLabel from "@material-ui/core/FormControlLabel/index";
import axios from "axios";
import { useSelector } from "react-redux";
import { updateObject } from "../../../helpers/updateObject";

function Users(props) {
  const token = useSelector((state) => state.auth.token);
  const [users, setUsers] = useState([]);
  const [chooseUserId, setChooseUserId] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [deleteUsersIds, setDeleteUsersIds] = useState([]);
  const [showView, setShowView] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showFilter, setShowFilter] = React.useState(false);
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(10);
  const [count, setCount] = useState(0);
  const [orderBy, setOrderBy] = useState("desc");
  const [sortField, setSortField] = useState("id");
  const [filterInputs, setFilterInputs] = useState({
    name: "",
    surname: "",
    middleName: "",

    roleId: "",
    
  
  });
  const toggleDrawer = (open) => (event) => {
    setShowView(open);
  };
  function handleChange() {
    setShowFilter((key) => !key);
  }

  const onUsers = (orderBy, sortField, skip, take, filterInputs = {}) => {
    const {
        name,
        surname,
        middleName,
        roleId,
      
    } = filterInputs;
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}user/role?dir=${orderBy}&field=${sortField}&pageNumber=${skip}&pageSize=${take}${middleName ? `&middleName=${middleName}` : ""}${name ? `&name=${name}` : ""}${roleId ? `&roleId=${roleId}` : ""}${surname ? `&surname=${surname}` : ""}`, {
        headers: { Authorization: `bearer ${token}` },
      })
      .then(({ data: { content ,totalElements} }) => {
        setIsLoading(false);
        setUsers(content);
        setIsError(false);
        setCount(totalElements)
      })
      .catch(() => {
        setIsLoading(false);
        setUsers([]);
        setIsError(true);
      });
  };

  const onUserChoose = (id) => {
    return axios.get(`${process.env.REACT_APP_API_URL}user/role/${id}`, {
      headers: { Authorization: `bearer ${token}` },
    });
  };

  const filterInputsUpdate = (name, value) => {
    const updateFiltersInput = updateObject(filterInputs, {
      [name]: value,
    });

    setFilterInputs(updateFiltersInput);
    setSkip(0);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      onUsers(orderBy, sortField, skip, take, filterInputs);
    }, 500);
    return () => clearTimeout(timer);
  }, [orderBy, sortField, skip, take, filterInputs]);


  const [roleId, setRoleId] = useState();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}role/select`)
      .then((res) => {
        const role = res.data.map(({ id, name }) => ({
          value: id,
          label: name,
        }));

        setRoleId(role);
      });
  }, []);



  return (
    <div className="row bg-white rounded">
      <div className="col-12 d-flex align-items-center py-4">
        <h1 className="display-4 mb-0">İstifadəçi  icazələri</h1>
        <FormControlLabel
          control={
            <Switch
              checked={showFilter}
              onChange={handleChange}
              color="secondary"
            />
          }
          label={showFilter ? "Filtri gizlət" : "Filtri göstər"}
          className="ml-auto mb-0"
        />
      </div>
      <Divider className="w-100" />
      <UsersTable
        users={users}
        isLoading={isLoading}
        isError={isError}
        setChooseUserId={setChooseUserId}
        setOpenView={toggleDrawer(true)}
        setShowEdit={setShowEdit}
        setDeleteUsersIds={setDeleteUsersIds}
        deleteUsersIds={deleteUsersIds}
        setSortField={setSortField}
        setOrderByTable={setOrderBy}
        sortField={sortField}
        orderBy={orderBy}
        count={count}
        updateSkip={setSkip}
        updateTake={setTake}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
      />
    

      {showView && (
        <View
          open={showView}
          onClose={toggleDrawer(false)}
          onUserChoose={onUserChoose}
          chooseUserId={chooseUserId}
        />
      )}

      

      {showEdit && (
        <Edit
          show={showEdit}
          onHide={setShowEdit}
          onUsers={onUsers}
          chooseUserId={chooseUserId}
          onUserChoose={onUserChoose}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
          filterInputs={filterInputs}
          roleId={roleId}

        />
      )}


      <Filter
        show={showFilter}
        onHide={handleChange}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
        setFilterInputs={setFilterInputs}
        roleId={roleId}
      />
     
    </div>
  );
}

export default Users;
